import lodash from 'lodash';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BasesController } from '../bases';
export class SNReportController<T = any> extends BasesController<T> {
  constructor() {
    super();
    this.reset({
      dataKey: 'id',
      infinite: true,
      pagination: EnumAPI.reporting_business_list,
      details: EnumAPI.reporting_business_detail,
      paginationParams: {
        currentKey: 'curPageNo',
        pageSizeKey: 'pageSize',
        filterKey: 'search',
        defaultPageSize: 20,
        response: {
          dataSource: 'data',
          total: 'total',
        },
      },
    });
  }
  /**
   * SN上报(输入)
   */
  async onSaveSN(body) {
    return await AjaxBasics.request({
      ...EnumAPI.reporting_business_submit,
      body,
    });
  }
  /**
   * sn码上传错误信息导出
   */
  async onExportErrData(body) {
    return await AjaxBasics.request<any>(
      lodash.assign(EnumAPI.reporting_business_fail, {
        responseType: 'blob',
        body,
      }),
    );
  }
  /**
   * sn码单条上报（移动端用）
   */
  async onSaveSingleSN(body) {
    return await AjaxBasics.request({
      ...EnumAPI.reporting_business_submit_single,
      body,
    });
  }
}
